import { Component, AfterViewInit, OnInit, ViewChild, Output, EventEmitter, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Color } from '../color';
import * as ace from 'ace-builds';
import 'ace-builds/src-min/mode-latex';
import 'ace-builds/src-min/theme-clouds';
import 'ace-builds/src-min/ext-language_tools';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css'],
  standalone: false
})
export class EditComponent implements OnInit, AfterViewInit {

  @ViewChild('editor') private editor!: ElementRef<HTMLElement>;
  private aceEditorInstance: ace.Editor | undefined;

  @Output()generatePressed = new EventEmitter();

  private _source: string = '';
  set source(value: string) {
    console.log("source" + value);
    this._source = value;
    this.aceEditorInstance.session.setValue(this.source);
    this.change.detectChanges();
  }
  get source() {
    return this._source;
  }

  private _platform = "";
  set platform(value: string) {
    this._platform = value;
    this.aceEditorInstance.session.setValue(this.source);
  }
  get platform() {
    return this._platform;
  }
  
  constructor(
    private change: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    console.log("EditComponent.ngAftterViewInit()");
    ace.config.set('basePath', 'https://cdn.jsdelivr.net@' + ace.version + '/src-min/');
    this.aceEditorInstance = ace.edit(this.editor.nativeElement);
    this.aceEditorInstance.setOptions({
      mode: 'ace/mode/latex',
      theme: 'ace/theme/clouds',
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
    });
    this.aceEditorInstance.session.setValue(this.source);

    const handler = this.aceEditorInstance.getKeyboardHandler();
    this._platform = (handler as any).platform || 'unknown';
    const component = this;
    this.aceEditorInstance.commands.addCommand({
      name: 'savefile',
      bindKey: { win: 'Ctrl-S', mac: 'Cmd-S' },
      exec: function (editor: any) {
	console.log('generatePressed');
        component.generatePressed.emit();
      }
    } as any);

    this.aceEditorInstance.session.on('change', () => {
	console.log('editor.change');
	this._source = this.aceEditorInstance?.getValue();
    });
  }

  setColor(color: Color): void {
    const cmd = `\\textcolor[rgb]{${color.r},${color.g},${color.b}}`;
    const ace = this.aceEditorInstance;
    const selection = ace.getSelection();
    if (selection) {
      for (const range of selection.getAllRanges()) {
	const text = ace.session.getTextRange(range);
	ace.session.replace(range, `${cmd}{${text}}`);
      }
    } else {
	console.log("no selection to set color");
    }
  }
}
